import React, { useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import CreateFarmModal from 'screens/Property/PropertiesLanding/PropertyCreate/components/CreateFarmModal';
import useFarmData from 'screens/Property/hooks/useFarmData';
import '../../index.css';
import { Context } from 'components/Store';
import { FINANCIAL_ACCESSES, ROLES, hasAccess } from 'utilities/access';
import { AmplitudeContext } from 'utilities/amplitude/useAmplitude';
import PropertyLandingContext from '../../context';
import Actions from './components/Actions';

const panelFooterDefaultPropReloadFarmData = () => {};
const PanelFooter = ({
  showTools = false,
  reloadFarmData = panelFooterDefaultPropReloadFarmData,
  openCreateModal,
  setView
}) => {
  const { createFarm } = useFarmData(null, false);
  const [openFarmModal, setOpenFarmModal] = useState(false);
  const { guardNavigation } = useContext(PropertyLandingContext);

  // Starting a new farm leaves an open crop zone form the same way picking a
  // different property does, so it asks first when that form is dirty.
  const onCreateFarm = useCallback(
    () => guardNavigation(() => setOpenFarmModal(true)),
    [guardNavigation]
  );
  const amplitude = useContext(AmplitudeContext);
  const [
    { isMassAssignerActive, loggedInUserOrgPermission, isExportPDFMapsActive }
  ] = useContext(Context);

  const { role, financialAccess } = loggedInUserOrgPermission;

  const withoutAccess = useMemo(
    () =>
      !hasAccess(
        { role, financialAccess },
        {
          minAllowedRole: ROLES.FULL_CONTROL,
          minFinancialAccess: FINANCIAL_ACCESSES.READ
        }
      ),
    [role, financialAccess]
  );
  const handleCreateFarm = async name => {
    await createFarm({
      name,
      timeZone: 'US/Central',
      referencePoint: {
        type: 'Point',
        coordinates: [0, 0]
      }
    });

    amplitude.sendEventToAmplitude(amplitude.events.epic.Properties.saveFarm, {
      navigationSource: 'New Property menu'
    });

    reloadFarmData();

    setOpenFarmModal(false);
  };

  // Without tools the footer is an empty padded bar with a top border, which
  // drew a stray line under the empty-properties message.
  if (
    isMassAssignerActive ||
    isExportPDFMapsActive ||
    withoutAccess ||
    !showTools
  )
    return null;
  return (
    <div className="p-4 sticky top-0 z-4 white-bg border-t border-neutral-20">
      <div>
        {showTools && (
          <Actions
            onCreateFarm={onCreateFarm}
            openCreateModal={openCreateModal}
            setView={setView}
          />
        )}
      </div>
      <CreateFarmModal
        open={openFarmModal}
        onCancel={() => setOpenFarmModal(false)}
        onCreate={handleCreateFarm}
      />
    </div>
  );
};

PanelFooter.propTypes = {
  showTools: PropTypes.bool,
  reloadFarmData: PropTypes.func,
  openCreateModal: PropTypes.func.isRequired,
  setView: PropTypes.func.isRequired
};

export default PanelFooter;
